// @ts-nocheck

class Spinner extends HTMLElement {
    /** @type {number|null} */
    #autoStopTimer = null;
  
    /** @type {AbortController|null} */
    #controller = null;
  
    connectedCallback() {
      this.#controller = new AbortController();
      const { signal } = this.#controller;
  
      window.addEventListener('spinner:start', this.#handleStart, { signal });
      window.addEventListener('spinner:stop', this.#handleStop, { signal });
    }
  
    disconnectedCallback() {
      this.#controller?.abort();
      this.#clearAutoStopTimer();
    }
  
    /**
     * @param {CustomEvent} event
     * @param {number} [event.detail.timer] - Optional auto-stop delay in ms
     */
    #handleStart = (event) => {
      const timer = event.detail?.timer;
      this.show(timer);
    };
  
    #handleStop = () => {
      this.hide();
    };
  
    /**
     * @param {number} [timer] - Optional auto-stop delay in ms
     */
    show(timer) {
      this.classList.add('ctr-spinner--active');
      if (typeof timer === 'number' && timer > 0) {
        this.#startAutoStopTimer(timer);
      }
    }
  
    hide() {
      this.classList.remove('ctr-spinner--active');
      this.#clearAutoStopTimer();
    }
  
    /**
     * @param {number} delay - Auto-stop delay in ms
     */
    #startAutoStopTimer(delay) {
      this.#clearAutoStopTimer();
      this.#autoStopTimer = setTimeout(() => {
        this.hide();
      }, delay);
    }
  
    #clearAutoStopTimer() {
      if (this.#autoStopTimer) {
        clearTimeout(this.#autoStopTimer);
        this.#autoStopTimer = null;
      }
    }
  }
  
  if (!customElements.get('ctr-spinner')) {
    customElements.define('ctr-spinner', Spinner);
  }